import { TextureLoader, CubeTextureLoader } from 'three';

class ResourceBatch {
  constructor() {
    this._queue = [];
    this._loaded = 0;
    this._totalBytes = 0;
    this._loadedBytes = 0;
    this._errors = [];
    this.loading_finished = false;
    this.has_errors = false;
  }

  add_texture(name, url, size = 1000) {
    this._queue.push({ type: 'texture', name, url, size });
    this._totalBytes += size;
  }

  add_cubemap(name, folder, size = 8000) {
    this._queue.push({ type: 'cubemap', name, folder, size });
    this._totalBytes += size;
  }

  load(container) {
    if (this._queue.length === 0) {
      this.loading_finished = true;
      return;
    }

    const texLoader = new TextureLoader();
    const cubeLoader = new CubeTextureLoader();
    const faces = ['px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'];

    this._queue.forEach(item => {
      if (item.type === 'texture') {
        texLoader.load(
          item.url,
          (texture) => {
            container.set_resource(item.name, texture);
            this._loadedBytes += item.size;
            this._loaded++;
            this._checkDone();
          },
          undefined,
          (err) => {
            this._errors.push(`Failed to load texture: ${item.url}`);
            this._loaded++;
            this._checkDone();
          }
        );
      } else if (item.type === 'cubemap') {
        cubeLoader.setPath(item.folder).load(
          faces,
          (cubeTexture) => {
            container.set_resource(item.name, cubeTexture);
            this._loadedBytes += item.size;
            this._loaded++;
            this._checkDone();
          },
          undefined,
          (err) => {
            this._errors.push(`Failed to load cubemap: ${item.folder}`);
            this._loaded++;
            this._checkDone();
          }
        );
      }
    });
  }

  _checkDone() {
    if (this._loaded >= this._queue.length) {
      this.loading_finished = true;
      this.has_errors = this._errors.length > 0;
    }
  }

  get_progress() {
    return this._queue.length === 0 ? 1 : this._loaded / this._queue.length;
  }

  get_loaded_bytes() {
    return this._loadedBytes;
  }

  get_total_bytes() {
    return this._totalBytes;
  }

  print_errors() {
    this._errors.forEach(e => console.error(e));
  }
}

export { ResourceBatch };
